export default "__VITE_ASSET__DsbuS7Ct__"